/* Collection page: filter dropdowns, price filter, sort, room/flat view, columns, load more. */
(function () {
  const $ = (id) => document.getElementById(id);
  const grid = $('grid'); if (!grid) return;
  const params = () => new URLSearchParams(location.search);
  const T = (window.RBCFG && window.RBCFG.t) || {};
  const tr = (k, fb) => T[k] || fb;
  const go = (p) => { p.delete('page'); location.href = `${location.pathname}?${p.toString()}`; };

  // mobile: expand the toolbar
  const tb = $('toolbar'), ft = $('filterToggle');
  if (ft) ft.addEventListener('click', () => { const on = tb.classList.toggle('expanded'); ft.setAttribute('aria-expanded', on); });

  // one dropdown open at a time; click outside closes
  const drops = [...document.querySelectorAll('.fdrop')];
  drops.forEach((d) => d.addEventListener('toggle', () => { if (d.open) drops.forEach((o) => { if (o !== d) o.open = false; }); }));
  document.addEventListener('click', (e) => { if (!e.target.closest('.fdrop')) drops.forEach((d) => { d.open = false; }); });

  // color chip: pick several colors, then "Show results" writes them all into the filter param at once
  document.querySelectorAll('[data-color-drop]').forEach((cd) => {
    const btn = cd.querySelector('.cchip'), key = cd.dataset.param;
    const items = [...cd.querySelectorAll('.citem')];
    const initial = items.filter((i) => i.classList.contains('on')).map((i) => i.dataset.value).sort().join('|');
    const setOpen = (on, focusBtn) => {
      cd.classList.toggle('open', on); btn.setAttribute('aria-expanded', on);
      if (on) drops.forEach((d) => { d.open = false; });
      else if (focusBtn) btn.focus();
    };
    const pick = (it, on) => { it.classList.toggle('on', on); it.setAttribute('aria-pressed', on); };
    items.forEach((it) => {
      it.setAttribute('role', 'button');
      it.addEventListener('click', (e) => { e.preventDefault(); pick(it, !it.classList.contains('on')); });
      it.addEventListener('keydown', (e) => { if (e.key === ' ') { e.preventDefault(); it.click(); } });
    });
    btn.addEventListener('click', () => setOpen(!cd.classList.contains('open')));
    drops.forEach((d) => d.addEventListener('toggle', () => { if (d.open) setOpen(false); }));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && cd.classList.contains('open')) { e.preventDefault(); setOpen(false, true); } });
    document.addEventListener('click', (e) => { if (cd.classList.contains('open') && !cd.contains(e.target)) setOpen(false); });
    cd.querySelector('[data-color-clear]').addEventListener('click', (e) => {
      if (!initial) { e.preventDefault(); items.forEach((i) => pick(i, false)); }
    });
    cd.querySelector('[data-color-apply]').addEventListener('click', () => {
      const chosen = items.filter((i) => i.classList.contains('on')).map((i) => i.dataset.value);
      if (chosen.slice().sort().join('|') === initial) { setOpen(false, true); return; }
      const p = params(); p.delete(key); chosen.forEach((v) => p.append(key, v)); go(p);
    });
  });

  // price range: two-handle slider kept in step with the two fields
  document.querySelectorAll('[data-price-form]').forEach((f) => {
    const max = +f.dataset.rangeMax || 1, wrap = f.querySelector('.range-dual');
    const lo = f.querySelector('[data-lo]'), hi = f.querySelector('[data-hi]'), loIn = f.querySelector('[data-lo-in]'), hiIn = f.querySelector('[data-hi-in]');
    const paint = () => { wrap.style.setProperty('--lo', (100 * lo.value / max) + '%'); wrap.style.setProperty('--hi', (100 * hi.value / max) + '%'); };
    lo.addEventListener('input', () => { if (+lo.value > +hi.value) lo.value = hi.value; loIn.value = lo.value; paint(); });
    hi.addEventListener('input', () => { if (+hi.value < +lo.value) hi.value = lo.value; hiIn.value = hi.value; paint(); });
    loIn.addEventListener('change', () => { lo.value = Math.min(+loIn.value || 0, +hi.value); loIn.value = lo.value; paint(); });
    hiIn.addEventListener('change', () => { hi.value = Math.max(+hiIn.value || max, +lo.value); hiIn.value = hi.value; paint(); });
    f.addEventListener('submit', (e) => {
      e.preventDefault(); const p = params();
      +lo.value > 0 ? p.set(f.dataset.min, lo.value) : p.delete(f.dataset.min);
      +hi.value < max ? p.set(f.dataset.max, hi.value) : p.delete(f.dataset.max);
      go(p);
    });
  });

  // size filter: grouped into area rugs, runners (by length), round, mats; each group sorted
  document.querySelectorAll('[data-size-filter] .chips').forEach((box) => {
    const U = window.RBUI; const chips = [...box.querySelectorAll('a.chip')];
    const groups = { area: [], runner: [], round: [], mat: [], other: [] };
    chips.forEach((c) => {
      const node = c.childNodes[0]; const label = ((node && node.textContent) || c.textContent).trim();
      const d = U && U.dims ? U.dims(label) : null; let g = 'other', key = 0;
      const run = label.match(/(\d+)\s*['′]\s*long\s*runner/i);
      if (/mat|doormat/i.test(label)) g = 'mat';
      else if (run) { g = 'runner'; key = +run[1]; if (node && node.nodeType === 3) node.textContent = `${run[1]}′ ${tr('long', 'long')}`; }
      else if (d && d.round) { g = 'round'; key = d.w; }
      else if (d) { const S = Math.min(d.w, d.h), L = Math.max(d.w, d.h); g = L / S >= 2.2 ? 'runner' : 'area'; key = S * L; }
      groups[g].push({ c, key });
    });
    const names = { area: tr('grp_area', 'Area rugs'), runner: tr('grp_runner', 'Runners'), round: tr('grp_round', 'Round'), mat: tr('grp_mats', 'Mats & doormats'), other: tr('grp_other', 'Other sizes') };
    box.innerHTML = ''; box.classList.add('chips-grouped');
    Object.keys(groups).forEach((g) => {
      if (!groups[g].length) return;
      const sec = document.createElement('div'); sec.className = 'chip-group';
      sec.innerHTML = `<div class="eyebrow">${names[g]}</div><div class="chips"></div>`;
      groups[g].sort((a, b) => a.key - b.key).forEach(({ c }) => sec.lastElementChild.appendChild(c));
      box.appendChild(sec);
    });
    const panel = box.closest('.fpanel'); if (panel) panel.classList.add('fpanel-wide');
  });

  // sort
  const sort = $('sort');
  if (sort) sort.addEventListener('change', () => { const p = params(); p.set('sort_by', sort.value); go(p); });

  // room / flat view (kept in the URL so "View every rug flat" links work)
  // hover photos load on demand (rb-card); the flat view shows them, so load them all when it is on
  const wakeFlat = () => grid.querySelectorAll('img.b[data-src]').forEach((img) => {
    img.addEventListener('load', () => img.classList.add('ready'), { once: true });
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
    img.src = img.dataset.src; img.removeAttribute('data-src');
  });
  const setView = (v) => {
    grid.classList.toggle('view-flat', v === 'flat');
    if (v === 'flat') wakeFlat();
    document.querySelectorAll('[data-view]').forEach((b) => b.classList.toggle('on', b.dataset.view === v));
  };
  setView(params().get('view') === 'flat' ? 'flat' : 'room');
  document.querySelectorAll('[data-view]').forEach((b) => b.addEventListener('click', () => {
    setView(b.dataset.view);
    const p = params(); b.dataset.view === 'flat' ? p.set('view', 'flat') : p.delete('view');
    history.replaceState(null, '', `${location.pathname}${p.toString() ? '?' + p : ''}`);
  }));

  // columns
  document.querySelectorAll('[data-cols]').forEach((b) => b.addEventListener('click', () => {
    grid.style.setProperty('--cols', b.dataset.cols);
    document.querySelectorAll('[data-cols]').forEach((o) => o.classList.toggle('on', o === b));
  }));

  // load more: fetch the next page and append its cards
  const btn = $('loadMoreBtn');
  if (btn) btn.addEventListener('click', async (e) => {
    e.preventDefault();
    if (btn.dataset.busy) return; btn.dataset.busy = '1'; btn.textContent = tr('loading', 'Loading…');
    try {
      const html = await (await fetch(btn.href)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cards = [...doc.querySelectorAll('#grid > .card')];
      cards.forEach((c) => grid.appendChild(document.importNode(c, true)));
      if (grid.classList.contains('view-flat')) wakeFlat();
      const shown = grid.querySelectorAll(':scope > .card').length;
      $('loadMoreCount').textContent = `${tr('showing', 'Showing')} ${shown} ${tr('of', 'of')} ${btn.dataset.total}`;
      const next = doc.getElementById('loadMoreBtn');
      if (next) { btn.href = next.getAttribute('href'); btn.textContent = tr('show_more', 'Show more'); delete btn.dataset.busy; }
      else btn.remove();
      if (window.RBUI) window.RBUI.reveal(grid);
    } catch (err) { location.href = btn.href; }
  });
})();
